export default function urlHostResolver(subdomain?: string, path?: string) {
  return subdomain
    ? `https://${subdomain}.${process.env.NEXT_PUBLIC_ROOT_URL}${path}`
    : `https://${process.env.NEXT_PUBLIC_ROOT_URL}${path}`
}
